import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useCityLedgerMultipleInvoicesContext } from '../../../context/CityLedgerMultipleInvoicesContext';
import { SendReminderButtonLegacy, SendReminderButton, BulkProcessPayment } from './Buttons';

export const BulkActions = () => {
    const { selectedInvoices, ownerIds } = useCityLedgerMultipleInvoicesContext();
    const enableNewSendReminderDialog = useFeatureFlag(FeatureFlag.newSendReminderDialog);

    const isSendReminderButtonDisabled = enableNewSendReminderDialog
        ? !selectedInvoices || ownerIds.length > 1
        : selectedInvoices.length > 1 || !selectedInvoices[0].ownerId || !selectedInvoices[0].invoiceId;

    const SendReminder = enableNewSendReminderDialog ? SendReminderButton : SendReminderButtonLegacy;

    return (
        <>
            <SendReminder
                isSendReminderButtonDisabled={isSendReminderButtonDisabled}
                invoiceId={selectedInvoices[0].invoiceId}
                accountId={selectedInvoices[0].ownerId}
            />
            <BulkProcessPayment />
        </>
    );
};
